import type { FaqItem } from "@/components/shared/FAQ";
import type { HomeContent } from "../types";

export const PT_BR_FAQS: FaqItem[] = [
  {
    question: "Posso cancelar meu plano?",
    answer:
      "Sim. Você pode cancelar seu plano a qualquer momento nas configurações. O plano continua ativo até o fim do ciclo de cobrança.",
  },
  {
    question: "O que é um crédito de workflow?",
    answer:
      "Um crédito de workflow equivale a um vídeo gerado pela IA do Crayo. Isso inclui o AutoClip e outros workflows.",
  },
  {
    question: "Como vejo meu consumo?",
    answer:
      "Você pode ver seu consumo nas configurações. Clique na sua foto de perfil no canto superior direito.",
  },
  {
    question: "Vocês têm política de reembolso?",
    answer:
      "Infelizmente não oferecemos reembolso. Você pode cancelar seu plano quando quiser e ele continua ativo até o fim do ciclo de cobrança.",
  },
  {
    question: "O que é um minuto de exportação?",
    answer:
      "Um minuto de exportação é a duração de vídeo que você pode gerar com o Crayo. Por exemplo, com 60 minutos de exportação você pode gerar um vídeo de 1 minuto 60 vezes.",
  },
  {
    question: "Posso monetizar os vídeos criados com o Crayo?",
    answer: "Sim. Os direitos dos vídeos que você cria com o Crayo são totalmente seus.",
  },
  {
    question: "Posso gerar em outros idiomas?",
    answer:
      "Sim. Suportamos a maioria dos idiomas. É só escrever o texto no idioma em que você quer gerar. Fale com o suporte se precisar de um idioma que ainda não esteja disponível.",
  },
  {
    question: "Os créditos não usados acumulam?",
    answer:
      "Os créditos da assinatura são renovados todo mês em qualquer prazo do plano, seja pagamento mensal, trimestral ou anual, e os créditos não usados não acumulam. Os créditos de recargas avulsas são separados da sua cota mensal.",
  },
];

export const PT_BR_HOME: HomeContent = {
  seoTitle: "Crayo: editor de vídeo com IA para cortar clipes",
  seoDescription:
    "Editor de vídeo com IA para conteúdo curto. Cortar clipes com IA, legendas automáticas, vozes com IA e mais. Vídeos longos em shorts virais em segundos.",
  heading: {
    prefix: "A ferramenta",
    highlight: "#1 para clipar",
    suffix: "Edite vídeos virais com IA",
  },
  body: "Sua ferramenta tudo em um para cortar clipes automaticamente, vozes com IA, legendas que prendem a atenção e mais.",
  mobileBody: "Sua plataforma tudo em um para editar.",
  faqs: PT_BR_FAQS,
};
